import {useId} from "react";
import {css} from "@panda/css";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {SENT_APPLICATIONS_SUMMARY_TEST_IDS} from "@pg-mono/test-ids";

import {leadModalZindex} from "../../../application/constants/lead/lead_modal_zindex";
import {PropertyCarousel} from "../../../property/components/property_carousel/PropertyCarousel";
import {PropertyCarouselTile} from "../../../property/components/property_carousel/PropertyCarouselTile";
import {getPropertyRegionLocation} from "../../../property/utils/get_property_region_location";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {useRegistrationSentApplicationsProperties} from "../../hooks/use_registration_sent_applications_properties";
import {getRegistrationSentApplicationsTitle} from "../../utils/get_registration_sent_applications_title";

interface IProps {
    count: number;
    propertyIds: number[];
    onClose: () => void;
}

export const RegistrationSentApplicationsSummary = (props: IProps) => {
    const {count, propertyIds, onClose} = props;
    const titleId = useId();
    const descriptionId = useId();
    const {isLoading, properties} = useRegistrationSentApplicationsProperties(propertyIds);

    const content = (() => {
        if (isLoading) {
            return <Loader size="lg" fullWidth />;
        }

        if (properties.length === 0) {
            return null;
        }

        return (
            <PropertyCarousel
                size="large"
                itemCount={properties.length}
                previousButtonDataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.PREVIOUS_BUTTON}
                nextButtonDataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.NEXT_BUTTON}
            >
                {properties.map((property) => (
                    <PropertyCarouselTile
                        key={property.id}
                        size="large"
                        href={rpAppLink.property.detail.base({
                            vendorSlug: property.offer.vendor.slug,
                            offerSlug: property.offer.slug,
                            offerId: property.offer.id,
                            propertyId: property.id
                        })}
                        imageSrc={getThumbnailLink(property.offer.main_image_url, 350, 230)}
                        investmentName={property.offer.name}
                        rooms={property.rooms}
                        area={property.area}
                        floor={property.floor}
                        price={property.price}
                        currency={property.offer.currency}
                        location={getPropertyRegionLocation(property.offer.region, property.offer.address)}
                        dataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.PROPERTY_CARD}
                    />
                ))}
            </PropertyCarousel>
        );
    })();

    return (
        <ResponsiveModal
            isOpen
            onClose={onClose}
            zIndex={leadModalZindex}
            ariaLabelledBy={titleId}
            ariaDescribedBy={descriptionId}
            className={modalStyle}
            dataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.WRAPPER}
        >
            <ResponsiveModal.Header divider={false} className={headerStyle}>
                <BrandCheckboxCheckedIcon width={72} height={72} className={illustrationStyle} />

                <div className={headerTextStyle}>
                    <Text as="h2" id={titleId} variant="headline_4" color="var(--colors-secondary)">
                        {getRegistrationSentApplicationsTitle(count)}
                    </Text>
                    <Text as="p" id={descriptionId} variant="body_copy_2" color="var(--colors-secondary)" className={descriptionStyle}>
                        Oczekuj na kontakt od deweloperów w sprawie wybranych przez Ciebie ofert
                    </Text>
                </div>

                <ResponsiveModal.CloseButton dataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.CLOSE_BUTTON} />
            </ResponsiveModal.Header>

            {content ? <ResponsiveModal.Body className={bodyStyle}>{content}</ResponsiveModal.Body> : null}
        </ResponsiveModal>
    );
};

const modalStyle = css({
    "--responsive-modal-width": "81.2rem",
    md: {
        p: 3
    }
});

const headerStyle = css({
    display: "flex",
    alignItems: "flex-start",
    columnGap: "1rem",
    px: 2,
    py: 1.5
});

const illustrationStyle = css({
    display: "block",
    flexShrink: 0
});

const headerTextStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    flex: "1 1 auto",
    minWidth: 0
});

const descriptionStyle = css({
    lineHeight: "1.8rem",
    md: {
        lineHeight: "2rem"
    }
});

const bodyStyle = css({
    px: 2,
    py: 1.5
});
import {useId} from "react";
import {css} from "@panda/css";

import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {SENT_APPLICATIONS_SUMMARY_TEST_IDS} from "@pg-mono/test-ids";

import {leadModalZindex} from "../../../application/constants/lead/lead_modal_zindex";
import {PropertyCarousel} from "../../../property/components/property_carousel/PropertyCarousel";
import {PropertyCarouselTile} from "../../../property/components/property_carousel/PropertyCarouselTile";
import {getPropertyRegionLocation} from "../../../property/utils/get_property_region_location";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {useRegistrationSentApplicationsProperties} from "../../hooks/use_registration_sent_applications_properties";
import {getRegistrationSentApplicationsTitle} from "../../utils/get_registration_sent_applications_title";

interface IProps {
    count: number;
    propertyIds: number[];
    onClose: () => void;
}

export const RegistrationSentApplicationsSummary = (props: IProps) => {
    const {count, propertyIds, onClose} = props;
    const titleId = useId();
    const descriptionId = useId();
    const {isLoading, properties} = useRegistrationSentApplicationsProperties(propertyIds);

    const content = (() => {
        if (isLoading) {
            return <Loader size="lg" fullWidth />;
        }

        if (properties.length === 0) {
            return null;
        }

        return (
            <PropertyCarousel
                size="large"
                itemCount={properties.length}
                previousButtonDataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.PREVIOUS_BUTTON}
                nextButtonDataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.NEXT_BUTTON}
            >
                {properties.map((property) => (
                    <PropertyCarouselTile
                        key={property.id}
                        size="large"
                        href={rpAppLink.property.detail.base({
                            vendorSlug: property.offer.vendor.slug,
                            offerSlug: property.offer.slug,
                            offerId: property.offer.id,
                            propertyId: property.id
                        })}
                        imageSrc={getThumbnailLink(property.offer.main_image_url, 350, 230)}
                        investmentName={property.offer.name}
                        rooms={property.rooms}
                        area={property.area}
                        floor={property.floor}
                        price={property.price}
                        currency={property.offer.currency}
                        location={getPropertyRegionLocation(property.offer.region, property.offer.address)}
                        dataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.PROPERTY_CARD}
                    />
                ))}
            </PropertyCarousel>
        );
    })();

    return (
        <ResponsiveModal
            isOpen
            onClose={onClose}
            zIndex={leadModalZindex}
            ariaLabelledBy={titleId}
            ariaDescribedBy={descriptionId}
            className={modalStyle}
            dataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.WRAPPER}
        >
            <ResponsiveModal.Header divider={false} className={headerStyle}>
                <BrandCheckboxCheckedIcon width={72} height={72} className={illustrationStyle} />

                <div className={headerTextStyle}>
                    <Text as="h2" id={titleId} variant="headline_4" color="var(--colors-secondary)">
                        {getRegistrationSentApplicationsTitle(count)}
                    </Text>
                    <Text as="p" id={descriptionId} variant="body_copy_2" color="var(--colors-secondary)" className={descriptionStyle}>
                        Oczekuj na kontakt od deweloperów w sprawie wybranych przez Ciebie ofert
                    </Text>
                </div>

                <ResponsiveModal.CloseButton dataTestId={SENT_APPLICATIONS_SUMMARY_TEST_IDS.CLOSE_BUTTON} />
            </ResponsiveModal.Header>

            {content ? <ResponsiveModal.Body className={bodyStyle}>{content}</ResponsiveModal.Body> : null}
        </ResponsiveModal>
    );
};

const modalStyle = css({
    "--responsive-modal-width": "81.2rem",
    md: {
        p: 3
    }
});

const headerStyle = css({
    display: "flex",
    alignItems: "flex-start",
    columnGap: "1rem",
    px: 2,
    py: 1.5
});

const illustrationStyle = css({
    display: "block",
    flexShrink: 0
});

const headerTextStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    flex: "1 1 auto",
    minWidth: 0
});

const descriptionStyle = css({
    lineHeight: "1.8rem",
    md: {
        lineHeight: "2rem"
    }
});

const bodyStyle = css({
    px: 2,
    py: 1.5
});
